import type { ReactNode } from "react";
import type { TFunction } from "i18next";
import U2000ActionBtn from "../../../../../u2000Core/components/buttons/U2000ActionBtn";
import { NS } from "../../../../U3121";

export interface U3121BillingSummaryMetricRow {
  label: string;
  value: ReactNode;
}

interface U3121BillingSummaryMetricCardProps {
  title: string;
  metrics: U3121BillingSummaryMetricRow[];
  footer?: ReactNode;
  onViewDetail?: () => void;
  t: TFunction;
}

function U3121BillingSummaryMetricCard({ title, metrics, footer, onViewDetail, t }: U3121BillingSummaryMetricCardProps) {
  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-200 bg-surface p-4 shadow-xs">
      <h4 className="mb-3 shrink-0 text-sm font-semibold text-foreground">{title}</h4>
      <dl className="shrink-0 space-y-2">
        {metrics.map((row) => (
          <div key={row.label} className="flex items-baseline justify-between gap-2 text-sm">
            <dt className="text-muted-foreground">{row.label}</dt>
            <dd className="font-medium text-foreground tabular-nums">{row.value}</dd>
          </div>
        ))}
      </dl>
      {footer ? <div className="mt-3 shrink-0 border-t border-gray-100 pt-3">{footer}</div> : null}
      {onViewDetail ? (
        <>
          <div className="min-h-0 flex-1" aria-hidden="true" />
          <div className="mt-4 flex shrink-0 justify-end border-t border-gray-100 pt-3">
            <U2000ActionBtn label={t("btnViewDetail", { ns: NS })} handleClick={onViewDetail} variant="secondary" className="px-3! py-1.5! text-xs" />
          </div>
        </>
      ) : null}
    </div>
  );
}

export default U3121BillingSummaryMetricCard;
